
<template>
  <div class="body">
    <!-- 已签收 -->
    <baseBreadcrumb :page="$t('message.received')" :menu="$t('message.emergencyItems')" />
    <div class="body">
      <div class="search">
        <div class="start">
          <!-- 请输入物流单号 -->
          <div class="item">
            <el-input :placeholder="$t('message.pleaseEnterTheLogisticsNumber')" v-model="data.express_no"
              onfocus="this.select()" clearable>
            </el-input>
          </div>

          <!-- 开始日期-->
          <div class="item">
            <el-date-picker v-model="data.dateStart" :placeholder="$t('message.startDate')" class="Container"
              type="datetime" default-time="['00:00:00']" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>
          <!--  结束日期-->
          <div class="item">
            <el-date-picker v-model="data.dateEnd" :placeholder="$t('message.dateClosed')" class="Container"
              default-time="['23:59:59']" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 240px">
            </el-date-picker>
          </div>

          <!-- 按钮 -->
          <div class="item">
            <el-button type="primary" @click="search">{{
              $t("message.search")
            }}</el-button>
            <!-- <el-button @click="reset">{{ $t("message.reset") }}</el-button> -->
          </div>
        </div>
        <div class="end"></div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" v-if="show">
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>
          <!--  签收时间-->
          <el-table-column align="center" :label="$t('message.signForTime')" prop="receive_at" width="100px">
          </el-table-column>

          <!--  提出时间-->
          <el-table-column align="center" :label="$t('message.forwardTime')" prop="created_at" width="100px">
          </el-table-column>

          <!--  部门-->
          <el-table-column align="center" :label="$t('message.department')" prop="type_name">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.admin" :key="index">
                {{ item.role[0].organization.name }}
              </p>
            </template>
          </el-table-column>

          <!--  提交人-->
          <el-table-column align="center" :label="$t('message.submitOne')" prop="created_by_name">
          </el-table-column>
          <!-- 快递号 -->
          <el-table-column align="center" :label="$t('message.expressNo')" prop="express_no">
            <template slot-scope="scope">
              <el-link :href="
                'https://www.guoguo-app.com/queryByCode.htm?cptype=all&cpcode=&mailNo=' +
                scope.row.express_no
              " type="primary" target="_blank">{{ scope.row.express_no }}</el-link>
            </template>
          </el-table-column>
          <!-- 交易号 -->
          <el-table-column align="center" :label="$t('message.transactionNumber')" width="180px">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.order_purchase_express" :key="index">
                {{ item.express_no }}
              </p>
            </template>
          </el-table-column>

          <!-- 订单号 -->
          <el-table-column align="center" :label="$t('message.orderNumber')" width="180px">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.order_purchase_express" :key="index">
                {{ item.order_purchase.order_sn }} <br />
                {{ item.order_purchase.user.realname }}
              </p>
            </template>
          </el-table-column>
          <!-- 操作人员 -->
          <el-table-column align="center" :label="$t('message.operatingPersonne')" prop="created_by_name">
          </el-table-column>
          <!-- 类别 -->
          <el-table-column align="center" :label="$t('message.category')" prop="type_name">
          </el-table-column>
          <!-- 提出人备注 -->
          <el-table-column align="center" :label="$t('message.remarksOfProposer')" prop="remark">
          </el-table-column>
          <!-- 签收人 -->
          <el-table-column align="center" :label="$t('message.signForPeople')" prop="created_by_name">
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="data.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="data.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [{}],
      id: 0, // 修改ID
      show: true,
      data: {
        page: 1,
        pageSize: 10,
        express_no: "",
        status: "1",
      },
      express_no: "",
      total: 0,
    };
  },
  components: {},
  created() {
    this.urgentList();
  },
  methods: {
    urgentList() {
      this.$api.signInApi.urgentList(this.data).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        console.log(res);
      });
    },

    // 搜索
    search() {
      this.data.page = 1;
      this.urgentList();
    },
    // 重置
    reset() {
      this.data = {
        page: 1,
        pageSize: 10,
        express_no: "",
        status: "1",
      };
      this.urgentList();
    },
    // 分页
    handleCurrentChange(val) {
      this.data.page = val;
      this.urgentList();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.urgentList();
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin-bottom: 24px;
  display: flex;
  position: relative;
  justify-content: space-between;

  .entry {
    background-color: #ffa21d;
    border-color: #ffa21d;
  }

  .start {
    display: flex;

    .item {
      margin-right: 20px;
    }
  }

  .end {
    display: flex;
  }

  .item {
    margin-right: 24px;

    /deep/.el-date-editor {
      width: 220px;
    }
  }

  .select {
    width: 140px;
  }

  .add {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.table {
  p {
    margin-bottom: 5px;

    .el-button {
      width: 80px;
      text-align: center;
      padding: 9px 0;
    }
  }
}

.content {
  padding: 0 15px;

  /deep/.el-select {
    width: 100%;
  }
}
</style>